import { Axios, setAuthToken } from "./config/Axios";

////// AUTHENTICATION //////
// Register User
export const registerUser = async (params) => {
  setAuthToken();
  const response = await Axios.post("/auth/register", params);
  return response;
};

// Verify User
export const verifyAccount = async (params) => {
  setAuthToken();
  const response = await Axios.post("/auth/verify-account", params);
  return response;
};

// Login User
export const loginUser = async (params) => {
  setAuthToken();
  const response = await Axios.post("/auth/login", params);
  return response;
};

export const setPassword = async (params) => {
  setAuthToken();
  const response = await Axios.post("/auth/set-password", params);
  return response;
};

////// AUTHENTICATION //////

////// PRIVATE REQUESTS //////
// Get user Info
export const getUserInfo = async () => {
  setAuthToken();
  const response = await Axios.get("/admin/user-info");
  return response;
};

export const addCategory = async (params) => {
  setAuthToken();
  const response = await Axios.post("/admin/add-category", params);
  return response;
};

export const fetchCategories = async (params) => {
  setAuthToken();
  const response = await Axios.post("/admin/fetch-category", params);
  return response;
};

// Save Training Session
export const saveSession = async (formData) => {
  setAuthToken();
  const response = await Axios.post("/admin/save-session", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

export const getSessions = async (params) => {
  setAuthToken();
  const response = await Axios.post("/admin/fetch-sessions", params);
  return response;
};

export const updateSessionVisibility = async (params) => {
  setAuthToken();
  const response = await Axios.post("/admin/update-session-visibility", params);
  return response;
};

export const updateCategory = async (params) => {
  setAuthToken();
  const response = await Axios.post("/admin/edit-category", params);
  return response;
};

////// TRAINER REQUESTS //////

export const startTraining = async (params) => {
  setAuthToken();
  const response = await Axios.post("/trainer/start-training", params);
  return response;
};

export const startChat = async (params) => {
  setAuthToken();
  const response = await Axios.post("/trainer/chat", params);
  return response;
};

export const getTrainingSummary = async (params) => {
  setAuthToken();
  const response = await Axios.post("/trainer/get-summary", params);
  return response;
};

export const finalizeTraining = async (params) => {
  setAuthToken();
  const response = await Axios.post("/trainer/finalize-training", params);
  return response;
};
export const updateTraining = async (fromData) => {
  setAuthToken();
  const response = await Axios.post("/trainer/update-session", fromData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};
export const fetchPreviousTrainingSession = async (params) => {
  setAuthToken();
  const response = await Axios.post(`/trainer/fetch-chat`, params);
  return response;
};

// Transcribe audio
export const transcribeAudio = async (audioBlob, sessionId) => {
  setAuthToken();
  const formData = new FormData();

  // Determine the correct file extension based on the blob type
  let fileName = "audio.webm";
  if (audioBlob.type.includes("wav")) {
    fileName = "audio.wav";
  } else if (audioBlob.type.includes("mp3")) {
    fileName = "audio.mp3";
  } else if (audioBlob.type.includes("m4a")) {
    fileName = "audio.m4a";
  }

  formData.append("file", audioBlob, fileName);
  formData.append("sessionId", sessionId);

  const response = await Axios.post("/trainer/transcribe-audio", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

export const startReviewChat = async (params) => {
  setAuthToken();
  const response = await Axios.post("/trainer/review-session", params);
  return response;
};

export const reviewChat = async (params) => {
  setAuthToken();
  const response = await Axios.post("/trainer/review-chat", params);
  return response;
};

export const fetchLimitedUsers = async (params) => {
  setAuthToken();
  const response = await Axios.post("/admin/fetch-users-info", params);
  return response;
};

export const fetchUserCardInfo = async (params) => {
  setAuthToken();
  const response = await Axios.post("/admin/fetch-card-info", params);
  return response;
};

export const fetchSessionOverview = async (params) => {
  setAuthToken();
  const response = await Axios.post("/admin/fetch-session-overview", params);
  return response;
};

export const getLanguageData = async (params) => {
  setAuthToken();
  const response = Axios.post("/admin/fetch-languages-info", params);
  return response;
};

export const getUsersPerLanguageData = async (params) => {
  setAuthToken();
  const response = Axios.post("/admin/fetch-users-languages-info", params);
  return response;
};

export const getCostPerLanguageData = async (params) => {
  setAuthToken();
  const response = Axios.post("/admin/fetch-cost-data", params);
  return response;
};

export const downloadExcelReport = async (params) => {
  setAuthToken();
  const response = Axios.post("/admin/download-excel", params, {
    responseType: "blob",
  });
  return response;
};

export const fetchUserManagementInfo = async (params) => {
  setAuthToken();
  const response = Axios.post("/admin/user-management-details", params);
  return response;
};

export const fetchReviewManagementInfo = async (params) => {
  setAuthToken();
  const response = Axios.post("/admin/review-management-details", params);
  return response;
};

export const deleteUsers = async (params) => {
  setAuthToken();
  const response = Axios.post("/admin/delete-user", params);
  return response;
};

export const updateReviewStatus = async (params) => {
  setAuthToken();
  const response = Axios.post("/admin/update-review-status", params);
  return response;
};

export const fetchCostData = async () => {
  setAuthToken();
  const response = Axios.get("/admin/fetch-cost-graph-data");
  return response;
};

export const getTempTokenAzureSTT = async () => {
  setAuthToken();
  const response = await Axios.get("/admin/get-azure-token");
  return response;
};

////// PRIVATE REQUESTS //////
